import { render, staticRenderFns } from "./DocumentSelectDialog.vue?vue&type=template&id=2565304c&scoped=true&"
import script from "./DocumentSelectDialog.vue?vue&type=script&lang=js&"
export * from "./DocumentSelectDialog.vue?vue&type=script&lang=js&"
import style0 from "./DocumentSelectDialog.vue?vue&type=style&index=0&id=2565304c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2565304c",
  null
  
)

export default component.exports